import React, { ReactElement, useRef } from 'react';
import { Flex, Text, VStack, HStack } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';
import { WarningIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { QRActionButtons } from './QRActionButtons';

type Props = {
  worksheetUrl: string;
  hasCopied: boolean;
  onCopy: () => void;
  onDownload: (ref: React.RefObject<SVGSVGElement>) => void;
};

export const QRCodeDisplay = ({
  worksheetUrl,
  hasCopied,
  onCopy,
  onDownload,
}: Props): ReactElement => {
  const qrCodeRef = useRef<SVGSVGElement>(null);

  return (
    <Flex justify="center" alignItems="center" flexDir="column" gap="30px">
      <VStack width="100%" gap="l">
        <Text textStyle="body.s.regular" color="text.quaternary" width="100%">
          Teile den Link oder QR-Code – Lernende können das Arbeitsblatt damit direkt öffnen.
        </Text>
        <HStack width="100%" align="center" gap="7px">
          <NovaIcon icon={WarningIcon} size="l" color="icon.warning" aria-hidden />

          <Text textStyle="body.s.regular" color="text.tertiary" flex="1">
            Damit die Personen das Arbeitsblatt öffnen können, brauchen sie ein NOVAHEAL-Konto. Ein
            Abo ist dafür nicht notwendig.
          </Text>
        </HStack>
      </VStack>
      <QRCodeSVG ref={qrCodeRef} value={worksheetUrl} size={200} />
      <QRActionButtons
        onDownload={() => onDownload(qrCodeRef)}
        onCopy={onCopy}
        hasCopied={hasCopied}
      />
    </Flex>
  );
};
